module.exports = __webpack_public_path__ + "img/view_errors.dfe755f0.svg";